import { StringRecord } from '@/typings';

export const generateQueryString = (params: StringRecord) => {
  const queryParams = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== '')
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

  return queryParams.padStart(queryParams.length + 1, '?');
};
